import { render, staticRenderFns } from "./StudioProduct.vue?vue&type=template&id=4d2dbdc3&scoped=true&"
import script from "./StudioProduct.vue?vue&type=script&lang=js&"
export * from "./StudioProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2dbdc3",
  null
  
)

export default component.exports